import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import {Modal} from 'react-bootstrap'
import { KTSVG } from '../../../_metronic/helpers'
import * as Yup from 'yup'
import useUtils from './useUtils'
import { Formik } from 'formik'

type Props = {
    show: boolean
    handleClose: () => void
    cohort:any
    currentCohort:any
    setCohort:any
  }
const modalsRoot = document.getElementById('root-modals') || document.body



function EditCohort({show, handleClose, cohort, currentCohort, setCohort}: Props) {

    const {handleEdit} = useUtils()
      const handleSubmit = async(values:any) => {

       const res = await handleEdit(values?.isActive, cohort?.id, cohort?.title);
       if(res){
        setCohort()
        handleClose()
       }
      };

      const initialValues = {
        isActive : true
      };

    return createPortal(
        <Modal
          id='kt_modal_create_app'
          aria-hidden='true'
          size="sm"
          dialogClassName='modal-dialog modal-dialog-centered'
          show={show}
          onHide={handleClose}
        >
          <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
          <div className='modal-body '>
          <h2 className='d-flex justify-content-center align-items-center'>{cohort?.title}</h2>
          <div className='pt-2'>
                  {/* end::Body */}
                  <div className="d-flex justify-content-center gap-3 fs-6">
                <div>{new Date(Number(cohort?.startDate)).toISOString().split('T')[0]}</div>
                <div>To</div>
                <div>{new Date(Number(cohort?.endDate)).toISOString().split('T')[0]}</div> 
                </div>

                <div className="pt-4 mb-3">
                  <div className="fs-6">
                    <div className="d-flex justify-content-between w-100 bg-secondary p-2 bg-grey ms-auto me-auto align-items-center flex-wrap">
                    <div>Activate {cohort.title}</div>
             


                    <label className='form-check form-check-custom form-check-solid form-switch'>  
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={values.isActive}
                        onClick={() => setFieldValue('isActive', values.isActive)}
                      />
                    </label>


    
                </div>
                <div className="d-flex align-items-start gap-1 fs-7"> <svg style={{marginTop:'0.15rem'}} xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg> By activating {cohort.title} you will inactivate the {currentCohort} </div>
                </div>
                </div>
               
                </div>
                <div className='d-flex align-items-center  justify-content-center my-5'>
                <button
                  type='button'
                  className='btn btn-danger ms-2 mt-2 me-2'
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button type='submit' className='btn btn-primary ms-2 mt-2 me-2'>
                  Activate
                </button>
              </div>
          </div>
  
              </form>
          )}
        </Formik>
        </Modal>,
        modalsRoot
      )
}

export default EditCohort